import Vuex from 'vuex'
import Vue from 'vue'
import * as mutations from './mutations'
import cookie from 'js-cookie'
import createPersistedState from 'vuex-persistedstate'
import { cookieDomainName } from "@/api/global_variable";
Vue.use(Vuex)

export default new Vuex.Store({

  state: {
    menuList: [], // 菜单权限
    menu: false
  },
  mutations: {
    updateHeadImage(state, val) {
      state.userInfo.headImage = val;
    },
    updateNickName(state, val) {
      state.userInfo.nickName = val;
    },
    logout(state) {//退出登录
      console.log('退出登录')
      state.userInfo = {}
      cookie.set("SysGph", '', { expires: -1, path: '/', domain: cookieDomainName });// 将用户cookie清空
      console.log(cookie.get('SysGph'))

    },
    login(state, val) {//登录
      console.log('登录')
      console.log(val)
      state.userInfo = val;
      //cookie.set("SysGph", userInfo, {path:'/', domain:cookieDomainName});


    },
    saveMenu(state, val) {//菜单
      state.menuList = val;
    },
  },
  plugins: [createPersistedState()]
})



// WEBPACK FOOTER //
// ./src/vuex/store.js